module.exports = __webpack_public_path__ + "static/media/tree.c301dd1f.svg";